import RouteContainer from "../../containers/RouteContainer";

/**
 * 管理者メインコンポーネント
 * @returns {JSX.Element}
 * @constructor
 */
const Contents = () => {
    return (
        <div className="makeStyles-content-4" style={{paddingBottom: 50}}>
            <RouteContainer/>
        </div>
    )
}
export default Contents
